import { render, staticRenderFns } from "./Articles.html?vue&type=template&id=2e3dba8b&scoped=true&"
import script from "./Articles.js?vue&type=script&lang=js&"
export * from "./Articles.js?vue&type=script&lang=js&"
import style0 from "./Articles.scss?vue&type=style&index=0&id=2e3dba8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3dba8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
